import { render } from "./DCatalogueItemCreateEditDialog.vue?vue&type=template&id=45d80781&scoped=true&ts=true"
import script from "./DCatalogueItemCreateEditDialog.vue?vue&type=script&lang=ts"
export * from "./DCatalogueItemCreateEditDialog.vue?vue&type=script&lang=ts"

import "./DCatalogueItemCreateEditDialog.vue?vue&type=style&index=0&id=45d80781&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\330398ee0e098db7\\LoadingSokoldok\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d80781"]])

export default __exports__